/* DUNKPOINT cart drawer + floating checkout pill. */
(function () {
  'use strict';

  var root = document.querySelector('[data-dp-cart]');
  if (!root) return;

  var cfgEl = document.getElementById('dp-cart-config');
  var CFG = {};
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { CFG = {}; }
  var upsells = Array.isArray(CFG.upsells) ? CFG.upsells : [];

  var pill = document.querySelector('[data-dp-pill]');
  var els = {
    count: root.querySelector('[data-dp-count]'),
    items: root.querySelector('[data-dp-items]'),
    empty: root.querySelector('[data-dp-empty]'),
    emptyGrid: root.querySelector('[data-dp-empty-grid]'),
    reserve: root.querySelector('[data-dp-reserve]'),
    reserveTime: root.querySelector('[data-dp-reserve-time]'),
    upsell: root.querySelector('[data-dp-upsell]'),
    upsellList: root.querySelector('[data-dp-upsell-list]'),
    foot: root.querySelector('[data-dp-foot]'),
    sub: root.querySelector('[data-dp-sub]'),
    saveRow: root.querySelector('[data-dp-save-row]'),
    save: root.querySelector('[data-dp-save]'),
    total: root.querySelector('[data-dp-total]'),
    checkoutTotal: root.querySelector('[data-dp-checkout-total]'),
    barFill: root.querySelector('[data-dp-bar]'),
    shipText: root.querySelector('[data-dp-ship-text]')
  };

  var cart = null;
  var compareCache = {};
  var modelCache = {};   /* handle -> variantModel, filled with the compare prices */
  var busy = false;

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function number(cents, precision, thousands, decimal) {
    var value = (cents / 100).toFixed(precision);
    var parts = value.split('.');
    var head = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    return head + (parts[1] ? decimal + parts[1] : '');
  }

  function money(cents) {
    var fmt = CFG.moneyFormat || '{{amount}}';
    var token = /\{\{\s*(\w+)\s*\}\}/;
    var match = fmt.match(token);
    var value;
    switch (match && match[1]) {
      case 'amount_no_decimals': value = number(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = number(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = number(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = number(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = number(cents, 0, ' ', ''); break;
      default: value = number(cents, 2, ',', '.');
    }
    return fmt.replace(token, value);
  }
  window.dpMoney = money;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function isSizeName(name) { return /size|tama|talla|taille|gr(o|ö)sse/i.test(name || ''); }

  function optionNames(data) {
    return (data.options || []).map(function (o) { return typeof o === 'string' ? o : o.name; });
  }

  /* Size first, the same order as the product page. */
  function orderedIndexes(names) {
    var order = [];
    names.forEach(function (name, i) { if (isSizeName(name)) order.push(i); });
    names.forEach(function (name, i) { if (order.indexOf(i) < 0) order.push(i); });
    return order;
  }

  /* ---------- option pickers (cart lines and "Upgrade your order") ----------
     A product reduced to its option names and variants, from either a
     /products/x.js payload, a recommendations product or the drawer config. */
  function variantModel(data) {
    var names = optionNames(data);
    var variants = (data.variants || []).map(function (v) {
      return {
        id: v.id,
        opts: names.map(function (n, i) { return v['option' + (i + 1)]; }),
        available: v.available !== false
      };
    });
    var values = names.map(function (n, i) {
      var list = [];
      variants.forEach(function (v) { if (v.opts[i] != null && list.indexOf(v.opts[i]) < 0) list.push(v.opts[i]); });
      return list;
    });
    return { names: names, values: values, variants: variants };
  }

  function findVariant(m, picks) {
    return m.variants.filter(function (v) {
      return v.opts.every(function (o, i) { return picks[i] == null || o === picks[i]; });
    })[0] || null;
  }

  /* One <select> per option with more than one value, size first. A value is
     disabled when it would land on a sold out (or missing) variant given the
     other current picks. */
  function pickerSelects(m, picks, cls, attr, labelled) {
    return orderedIndexes(m.names).map(function (i) {
      if (m.values[i].length < 2) return '';
      var opts = m.values[i].map(function (value) {
        var trial = picks.slice();
        trial[i] = value;
        var v = findVariant(m, trial);
        var off = !v || !v.available;
        return '<option value="' + esc(value) + '"' + (value === picks[i] ? ' selected' : '') + (off && value !== picks[i] ? ' disabled' : '') + '>' + esc(value) + '</option>';
      }).join('');
      var select = '<select class="' + cls + '" ' + attr + '="' + i + '" aria-label="' + esc(m.names[i]) + '">' + opts + '</select>';
      /* Short visible label: "Choose Player" reads as "Player". */
      var short = String(m.names[i]).replace(/^choose\s+(your\s+)?/i, '');
      return labelled ? '<label class="dp-cd__var"><span>' + esc(short) + '</span>' + select + '</label>' : select;
    }).join('');
  }

  function readPicks(container, attr, base) {
    var picks = base.slice();
    [].forEach.call(container.querySelectorAll('[' + attr + ']'), function (select) {
      picks[Number(select.getAttribute(attr))] = select.value;
    });
    return picks;
  }

  function hasChoice(m) {
    return m && m.variants.length > 1 && m.values.some(function (list) { return list.length > 1; });
  }

  function toUpsell(p) {
    var m = variantModel(p);
    return {
      id: p.id,
      title: p.title,
      url: p.url,
      image: p.featured_image || p.image || (p.images && p.images[0]) || null,
      price: p.price,
      compare: p.compare_at_price || p.compare || 0,
      model: m,
      variants: m.variants
    };
  }
  upsells = upsells.map(toUpsell);

  function openDrawer() {
    root.classList.add('is-open');
    root.removeAttribute('aria-hidden');
    document.body.classList.add('dp-cart-open');
    startReserve();
    syncPill();
    load();
  }

  function closeDrawer() {
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('dp-cart-open');
    syncPill();
  }

  function load() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        cart = data;
        render();
        fetchCompares();
        fetchRecommendations();
        return data;
      })
      .catch(function () {});
  }

  /* Cart AJAX does not return compare-at prices, so pull them per product once. */
  function fetchCompares() {
    if (!cart || !cart.items.length) return;
    var handles = [];
    cart.items.forEach(function (item) {
      if (item.handle && !(item.handle in compareCache) && handles.indexOf(item.handle) < 0) handles.push(item.handle);
    });
    if (!handles.length) { renderTotals(); return; }
    Promise.all(handles.map(function (handle) {
      return fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          var map = {};
          if (p && p.variants) {
            p.variants.forEach(function (v) { map[v.id] = v.compare_at_price || 0; });
            modelCache[handle] = variantModel(p);
          }
          compareCache[handle] = map;
        })
        .catch(function () { compareCache[handle] = {}; });
    })).then(function () {
      renderItems();
      renderTotals();
    });
  }

  /* "Upgrade your order" shows products related to what is already in the cart,
     from Shopify's own recommendations. The collection baked into the drawer
     config stays as the fallback for when there is nothing to recommend. */
  var recommended = null;

  function fetchRecommendations() {
    if (!cart || !cart.items.length) { recommended = null; return; }
    var productId = cart.items[0].product_id;
    if (recommended && recommended.forProduct === productId) return;
    fetch('/recommendations/products.json?product_id=' + productId + '&intent=related&limit=8',
      { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        var products = (data && data.products) || [];
        if (!products.length) { recommended = null; return; }
        recommended = { forProduct: productId, list: products.map(toUpsell) };
        renderUpsell();
      })
      .catch(function () { recommended = null; });
  }

  function compareFor(item) {
    var map = compareCache[item.handle];
    var value = map ? map[item.variant_id] : 0;
    return value && value > item.final_price ? value : 0;
  }

  function render() {
    renderItems();
    renderUpsell();
    renderTotals();
    renderShipping();
    syncBubble();
    syncPill();
    /* Lets other scripts (the bundle strip and picker, assets/dp-bundle.js)
       follow the cart without fetching it again. */
    try { document.dispatchEvent(new CustomEvent('dp:cart:updated', { detail: { cart: cart } })); } catch (e) {}
  }

  /* The pickers replace the option text when the line can be changed: the
     product has a real choice, its data has loaded, and it is not a free
     gift product (priced 0). A line made free by "buy 2, get the 3rd free"
     keeps its price and stays changeable. */
  function lineModel(item) {
    if (!item.price || !item.original_price) return null;
    var m = modelCache[item.handle];
    if (!hasChoice(m)) return null;
    var current = m.variants.filter(function (v) { return v.id === item.variant_id; })[0];
    return current ? { model: m, current: current } : null;
  }

  function itemOptions(item, withVariant) {
    var bits = [];
    var opts = withVariant === false ? [] : (item.options_with_values || []).filter(function (o) {
      return o.value && o.value !== 'Default Title';
    });
    opts.sort(function (a, b) { return (isSizeName(b.name) ? 1 : 0) - (isSizeName(a.name) ? 1 : 0); });
    opts.forEach(function (o) { bits.push(esc(o.name) + ': ' + esc(o.value)); });

    if (item.properties) {
      Object.keys(item.properties).forEach(function (k) {
        var value = item.properties[k];
        if (k.charAt(0) === '_' || !value) return;
        /* The options app appends its fee to the value, e.g. "(Name + Number) | 4.99". */
        value = String(value).split('|')[0].trim();
        if (value) bits.push(esc(k) + ': ' + esc(value));
      });
    }
    return bits;
  }

  function renderItems() {
    if (!cart) return;
    var empty = cart.item_count === 0;
    root.classList.toggle('is-empty', empty);
    els.empty.hidden = !empty;
    els.foot.hidden = empty;
    if (els.reserve) els.reserve.hidden = empty;
    els.count.textContent = '(' + cart.item_count + ')';
    if (empty) renderEmpty();

    els.items.innerHTML = cart.items.map(function (item) {
      var compare = compareFor(item);
      var img = item.image ? '<img src="' + esc(item.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2')) + '" alt="" loading="lazy">' : '';
      var lm = lineModel(item);
      var opts = itemOptions(item, !lm);
      var pickers = lm ? '<div class="dp-cd__vars">' + pickerSelects(lm.model, lm.current.opts, '', 'data-dp-var', true) + '</div>' : '';
      return '<div class="dp-cd__item" data-key="' + esc(item.key) + '">' +
        '<a class="dp-cd__thumb" href="' + esc(item.url) + '">' + img + '</a>' +
        '<div class="dp-cd__lmeta">' +
        '<div class="dp-cd__row1">' +
        '<a class="dp-cd__name" href="' + esc(item.url) + '">' + esc(item.product_title) + '</a>' +
        '<button type="button" class="dp-cd__rm" data-dp-remove aria-label="' + esc(CFG.removeLabel || 'Remove') + '">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6h18"/><path d="M8 6V4h8v2"/><path d="M19 6l-1 14H6L5 6"/><path d="M10 11v6M14 11v6"/></svg>' +
        '</button>' +
        '</div>' +
        /* Under the title: price, quantity and the property text on the
           left; the option selects stacked in their own column on the right. */
        '<div class="dp-cd__cols">' +
        '<div class="dp-cd__left">' +
        '<span class="dp-cd__prices">' +
        (compare ? '<s>' + money(compare * item.quantity) + '</s>' : '') +
        '<b>' + money(item.final_line_price) + '</b>' +
        '</span>' +
        '<span class="dp-cd__qty">' +
        '<button type="button" data-dp-qty="-1" aria-label="' + esc(CFG.decreaseLabel || 'Decrease') + '">&minus;</button>' +
        '<span>' + item.quantity + '</span>' +
        '<button type="button" data-dp-qty="1" aria-label="' + esc(CFG.increaseLabel || 'Increase') + '">+</button>' +
        '</span>' +
        (opts.length ? '<p class="dp-cd__opt">' + opts.join(' &middot; ') + '</p>' : '') +
        '</div>' +
        pickers +
        '</div>' +
        '</div>' +
        '</div>';
    }).join('');
  }

  /* ---------- empty cart: offer + a best sellers grid ---------- */
  var emptyBuilt = false;
  var emptyData = {};

  function renderEmpty() {
    if (!els.emptyGrid || emptyBuilt) return;
    var list = Array.isArray(CFG.emptyProducts) ? CFG.emptyProducts : [];
    if (!list.length) return;
    emptyBuilt = true;

    els.emptyGrid.innerHTML = list.map(function (p) {
      var off = p.compare > p.price ? Math.round(((p.compare - p.price) * 100) / p.compare) : 0;
      return '<div class="dp-ec__card" data-ec-handle="' + esc(p.handle) + '">' +
        (off ? '<span class="dp-ec__off">-' + off + '%</span>' : '') +
        '<a class="dp-ec__img" href="' + esc(p.url) + '">' +
        (p.image ? '<img src="' + esc(p.image) + '" alt="">' : '') + '</a>' +
        '<div class="dp-ec__body">' +
        '<a class="dp-ec__name" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
        '<span class="dp-ec__prices"><b>' + money(p.price) + '</b>' +
        (off ? '<s>' + money(p.compare) + '</s>' : '') + '</span>' +
        '<div class="dp-ec__opts" data-ec-opts></div>' +
        '<button type="button" class="dp-ec__add" data-ec-add disabled>' + esc(CFG.addLabel || '+ Add') + '</button>' +
        '</div></div>';
    }).join('');

    list.forEach(function (p) { hydrateEmptyCard(p.handle); });
  }

  function hydrateEmptyCard(handle) {
    fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data) return;
        emptyData[handle] = data;
        var card = els.emptyGrid.querySelector('[data-ec-handle="' + handle + '"]');
        if (!card) return;
        var names = optionNames(data);
        var order = orderedIndexes(names).slice(0, 2);

        card.querySelector('[data-ec-opts]').innerHTML = order.map(function (index) {
          var values = [];
          data.variants.forEach(function (v) {
            var value = v['option' + (index + 1)];
            if (value && values.indexOf(value) < 0) values.push(value);
          });
          if (values.length < 2) return '';
          return '<select class="dp-ec__sel" data-ec-opt="' + index + '" aria-label="' + esc(names[index]) + '">' +
            values.map(function (value) {
              return '<option value="' + esc(value) + '">' + esc(value) + '</option>';
            }).join('') + '</select>';
        }).join('');
        card.querySelector('[data-ec-add]').disabled = false;
      })
      .catch(function () {});
  }

  function addFromEmptyCard(card, button) {
    var data = emptyData[card.getAttribute('data-ec-handle')];
    if (!data) return;
    var picks = [].slice.call(card.querySelectorAll('[data-ec-opt]'));
    var variant = data.variants.filter(function (v) {
      return v.available && picks.every(function (select) {
        return v['option' + (Number(select.getAttribute('data-ec-opt')) + 1)] === select.value;
      });
    })[0];
    if (!variant) return;
    addVariant(variant.id, 1, button);
  }

  function renderUpsell() {
    if (!els.upsell) return;
    var inCart = {};
    if (cart) cart.items.forEach(function (i) { inCart[i.product_id] = true; });
    var source = (recommended && recommended.list.length) ? recommended.list : upsells;
    var list = source.filter(function (p) {
      return !inCart[p.id] && p.variants.some(function (v) { return v.available; });
    }).slice(0, 4);

    if (!list.length || !cart || !cart.item_count) { els.upsell.hidden = true; upsellShown = []; return; }
    els.upsell.hidden = false;
    upsellShown = list;
    els.upsellList.innerHTML = list.map(function (p, i) {
      var first = p.variants.filter(function (v) { return v.available; })[0];
      return '<div class="dp-cd__up" data-dp-up="' + i + '" data-picks="' + esc(JSON.stringify(first.opts)) + '">' +
        (p.image ? '<img src="' + esc(p.image) + '" alt="" loading="lazy">' : '<img alt="">') +
        '<div class="dp-cd__upinfo">' +
        '<a class="dp-cd__upname" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
        '<span class="dp-cd__upprice">' +
        (p.compare > p.price ? '<s>' + money(p.compare) + '</s>' : '') +
        '<b>' + money(p.price) + '</b>' +
        '</span>' +
        '<div class="dp-cd__upctl">' + upsellControls(p, first.opts, i) + '</div>' +
        '</div>' +
        '</div>';
    }).join('');
  }

  var upsellShown = [];

  function upsellControls(p, picks, i) {
    return pickerSelects(p.model, picks, 'dp-cd__upsel', 'data-dp-up-opt', false) +
      '<button type="button" class="dp-cd__upadd" data-dp-up-add="' + i + '">' + esc(CFG.addLabel || '+ Add') + '</button>';
  }

  /* Re-draw a card's selects after a pick so the disabled values follow it. */
  function onUpsellPick(card) {
    var i = Number(card.getAttribute('data-dp-up'));
    var p = upsellShown[i];
    if (!p) return;
    var base = JSON.parse(card.getAttribute('data-picks'));
    var picks = readPicks(card, 'data-dp-up-opt', base);
    var v = findVariant(p.model, picks);
    if (!v || !v.available) {
      /* Should not happen (sold out values are disabled), but fall back to the
         first available variant with the value just picked. */
      v = p.variants.filter(function (x) { return x.available && x.opts.some(function (o, k) { return o === picks[k]; }); })[0] || v;
    }
    if (v) picks = v.opts.slice();
    card.setAttribute('data-picks', JSON.stringify(picks));
    card.querySelector('.dp-cd__upctl').innerHTML = upsellControls(p, picks, i);
  }

  function renderTotals() {
    if (!cart) return;
    var gross = 0;
    var known = true;
    cart.items.forEach(function (item) {
      var compare = compareFor(item);
      if (!compare && !(item.handle in compareCache)) known = false;
      gross += (compare || item.final_price) * item.quantity;
    });
    var save = gross - cart.total_price;

    els.sub.innerHTML = money(known && save > 0 ? gross : cart.items_subtotal_price);
    if (known && save > 0) {
      els.saveRow.hidden = false;
      els.save.innerHTML = '&minus; ' + money(save);
    } else {
      els.saveRow.hidden = true;
    }
    els.total.innerHTML = money(cart.total_price);
    if (els.checkoutTotal) els.checkoutTotal.innerHTML = money(cart.total_price);
  }

  function renderShipping() {
    if (!els.barFill || !cart) return;
    var threshold = CFG.freeShipping || 0;
    if (!threshold || cart.total_price >= threshold) {
      els.barFill.style.width = '100%';
      els.shipText.classList.remove('is-away');
      els.shipText.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>' + esc(CFG.freeShippingOn || 'Shipping is FREE!');
    } else {
      els.barFill.style.width = Math.max(4, Math.round((cart.total_price / threshold) * 100)) + '%';
      els.shipText.classList.add('is-away');
      els.shipText.textContent = (CFG.freeShippingOff || 'You are [amount] away from free shipping').replace('[amount]', money(threshold - cart.total_price));
    }
  }

  /* The header count is rendered by Liquid, so it goes stale after an AJAX
     change, and it is missing entirely when the page loaded with an empty
     cart. Keep it in step and hide it again when the cart is emptied. */
  function syncBubble() {
    if (!cart) return;
    var link = document.getElementById('cart-icon-bubble');
    if (!link) return;
    var badge = link.querySelector('.dp-cart__count');
    if (!badge) {
      if (!cart.item_count) return;
      badge = document.createElement('span');
      badge.className = 'dp-cart__count';
      (link.querySelector('.dp-cart__icon') || link).appendChild(badge);
    }
    badge.textContent = cart.item_count;
    badge.hidden = cart.item_count === 0;
  }

  function syncPill() {
    if (!pill) return;
    var on = cart && cart.item_count > 0 && !root.classList.contains('is-open');
    pill.classList.toggle('is-on', !!on);
    if (!on) return;
    pill.querySelector('[data-dp-pill-n]').textContent = cart.item_count;
    placePill();
  }

  /* The pill sits above the Chatty bubble by default (dp-cart.css). Lift it
     further whenever Chatty or the product page's sticky add-to-cart bar
     reaches higher than that, so they never overlap. */
  var pillDefault = 92;
  function placePill() {
    if (!pill || !pill.classList.contains('is-on')) return;
    var lift = pillDefault;
    var chat = document.querySelector('.Avada-Faqs_Button');
    if (chat && chat.offsetWidth) {
      var r = chat.getBoundingClientRect();
      if (r.left < window.innerWidth - 10 && r.right > window.innerWidth - 90 && r.top > window.innerHeight / 2) {
        lift = Math.max(lift, Math.round(window.innerHeight - r.top) + 10);
      }
    }
    var sticky = document.querySelector('.dp-sticky.is-visible');
    if (sticky && sticky.offsetHeight) lift = Math.max(lift, sticky.offsetHeight + 12);
    pill.style.bottom = lift > pillDefault ? 'calc(env(safe-area-inset-bottom, 0px) + ' + lift + 'px)' : '';
  }
  var pillQueued = false;
  function queuePill() {
    if (pillQueued) return;
    pillQueued = true;
    requestAnimationFrame(function () { pillQueued = false; placePill(); });
  }
  window.addEventListener('scroll', queuePill, { passive: true });
  window.addEventListener('resize', queuePill);
  /* Chatty and the sticky bar both arrive or move a little after load. */
  [800, 2500, 6000].forEach(function (t) { setTimeout(placePill, t); });
  var stickyBar = document.querySelector('.dp-sticky');
  if (stickyBar && window.MutationObserver) {
    new MutationObserver(queuePill).observe(stickyBar, { attributes: true, attributeFilter: ['class'] });
  }

  var reserveTimer = null;
  function startReserve() {
    if (!els.reserveTime || reserveTimer) return;
    var minutes = CFG.reserveMinutes || 0;
    if (!minutes) return;
    var key = 'dp-cart-reserve';
    var until = 0;
    try { until = Number(sessionStorage.getItem(key) || 0); } catch (e) {}
    if (!until || until < Date.now() || until > Date.now() + minutes * 60000) {
      until = Date.now() + minutes * 60000;
      try { sessionStorage.setItem(key, String(until)); } catch (e) {}
    }
    function tick() {
      var left = Math.max(0, Math.round((until - Date.now()) / 1000));
      els.reserveTime.textContent = pad(Math.floor(left / 60)) + ':' + pad(left % 60);
      if (left <= 0) {
        clearInterval(reserveTimer);
        reserveTimer = null;
        if (els.reserve) els.reserve.hidden = true;
      }
    }
    tick();
    reserveTimer = setInterval(tick, 1000);
  }

  function changeLine(key, quantity) {
    if (busy) return;
    busy = true;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) { cart = data; render(); fetchCompares(); fetchRecommendations(); })
      .catch(function () {})
      .then(function () { busy = false; });
  }

  function addVariant(id, quantity, button) {
    if (busy) return;
    busy = true;
    if (button) button.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: quantity || 1 }] })
    })
      .then(function () { return load(); })
      .catch(function () {})
      .then(function () { busy = false; if (button) button.disabled = false; });
  }

  function addFromForm(form, button) {
    if (busy) return;
    busy = true;
    if (button) button.setAttribute('aria-busy', 'true');
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        busy = false;
        if (button) button.removeAttribute('aria-busy');
        if (data && data.status && data.status !== 200) return;
        openDrawer();
      })
      .catch(function () {
        busy = false;
        if (button) button.removeAttribute('aria-busy');
      });
  }

  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-dp-close]')) { closeDrawer(); return; }
    var qty = e.target.closest('[data-dp-qty]');
    if (qty) {
      var line = qty.closest('[data-key]');
      var current = Number(line.querySelector('.dp-cd__qty span').textContent) || 1;
      changeLine(line.getAttribute('data-key'), Math.max(0, current + Number(qty.getAttribute('data-dp-qty'))));
      return;
    }
    var remove = e.target.closest('[data-dp-remove]');
    if (remove) { changeLine(remove.closest('[data-key]').getAttribute('data-key'), 0); return; }
    var ecAdd = e.target.closest('[data-ec-add]');
    if (ecAdd) { addFromEmptyCard(ecAdd.closest('[data-ec-handle]'), ecAdd); return; }
    var add = e.target.closest('[data-dp-up-add]');
    if (add) {
      var card = add.closest('[data-dp-up]');
      var product = card && upsellShown[Number(card.getAttribute('data-dp-up'))];
      if (!product) return;
      var chosen = findVariant(product.model, readPicks(card, 'data-dp-up-opt', JSON.parse(card.getAttribute('data-picks'))));
      if (chosen && chosen.available) addVariant(chosen.id, 1, add);
      return;
    }
    var promoToggle = e.target.closest('[data-dp-promo-toggle]');
    if (promoToggle) { promoToggle.closest('[data-dp-promo]').classList.toggle('is-open'); return; }
    var promoApply = e.target.closest('[data-dp-promo-apply]');
    if (promoApply) {
      var code = root.querySelector('[data-dp-promo-input]').value.trim();
      if (code) window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(window.location.pathname);
      return;
    }
    if (e.target.closest('[data-dp-checkout]')) window.location.href = '/checkout';
  });

  root.addEventListener('change', function (e) {
    var upPick = e.target.closest('[data-dp-up-opt]');
    if (upPick) { onUpsellPick(upPick.closest('[data-dp-up]')); return; }
    var pick = e.target.closest('[data-dp-var]');
    if (!pick || !cart) return;
    var line = pick.closest('[data-key]');
    var key = line.getAttribute('data-key');
    var item = cart.items.filter(function (i) { return i.key === key; })[0];
    var lm = item && lineModel(item);
    if (!lm) return;
    var v = findVariant(lm.model, readPicks(line, 'data-dp-var', lm.current.opts));
    if (!v || !v.available || v.id === item.variant_id) { renderItems(); return; }
    line.classList.add('is-busy');
    swapLine(item, v.id);
  });

  /* Change a line's variant: add the new variant with the same quantity and
     every property (custom name / number / player, the app's hidden ones),
     then remove the old line. Adding first means a failed add (stock) leaves
     the cart as it was. The Ajax cart has no in-place variant swap, so the
     changed line moves to the top of the cart. */
  function sameProps(a, b) {
    function norm(p) {
      p = p || {};
      return JSON.stringify(Object.keys(p).sort().map(function (k) { return [k, p[k]]; }));
    }
    return norm(a) === norm(b);
  }

  function swapLine(item, variantId) {
    if (busy) return;
    busy = true;
    var entry = { id: Number(variantId), quantity: item.quantity, properties: item.properties || {} };
    if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan) {
      entry.selling_plan = item.selling_plan_allocation.selling_plan.id;
    }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [entry] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add');
        return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (res) { return res.json(); });
      })
      .then(function (fresh) {
        /* Line keys can change after the add (discounts are re-allocated), so
           find the old line again by its variant and properties. */
        var index = -1;
        fresh.items.forEach(function (i, n) {
          if (index < 0 && i.variant_id === item.variant_id && sameProps(i.properties, item.properties)) index = n;
        });
        if (index < 0) return fresh;
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line: index + 1, quantity: 0 })
        }).then(function (res) { return res.json(); });
      })
      .then(function (data) {
        busy = false;
        cart = data;
        render();
        fetchCompares();
        fetchRecommendations();
      })
      .catch(function () { busy = false; load(); });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.classList.contains('is-open')) closeDrawer();
  });

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('#cart-icon-bubble, [data-dp-cart-open], a[href$="/cart"], a[href$="/cart/"]');
    if (!trigger || trigger.closest('[data-dp-cart]')) return;
    e.preventDefault();
    openDrawer();
  }, true);

  if (pill) pill.addEventListener('click', function () { openDrawer(); });

  /* The product options app takes over the add-to-cart click and sends the
     shopper to /cart. Claim the click first and turn it into a form submit,
     which the handler below picks up. */
  document.addEventListener('click', function (e) {
    var button = e.target.closest('button[name="add"], button[type="submit"]');
    if (!button || button.disabled) return;
    var form = button.form || button.closest('form');
    if (!form || String(form.getAttribute('action') || '').indexOf('/cart/add') < 0) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
  }, true);

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.action || form.action.indexOf('/cart/add') < 0) return;
    e.preventDefault();
    e.stopPropagation();
    addFromForm(form, form.querySelector('[name="add"], [type="submit"]'));
  }, true);

  load();
})();
